module.exports = "<div class=\"split-view\">\n\n    <div class=\"split-view-left\" ng-if=\"$ctrl.viewLeftOpen\">\n        <ion-scroll delegate-handle=\"splitViewLeftScroll\">\n            <div class=\"split-view-content\" ng-transclude=\"splitViewLeft\"></div>\n        </ion-scroll>\n    </div>\n\n    <div class=\"split-view-right\" ng-if=\"$ctrl.viewRightOpen\">\n        <ion-scroll delegate-handle=\"splitViewRightScroll\">\n            <div class=\"split-view-content\" ng-transclude=\"splitViewRight\"></div>\n        </ion-scroll>\n    </div>\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/core/components/split-view/split-view.html
// module id = 928
// module chunks = 0